import { mutate, type ScopedMutator } from "swr";

// Include query variants (the historical catalog) and the recovery directory.
export const refreshApps = (refresh: ScopedMutator = mutate) => {
  return refresh((key) => Array.isArray(key) && (
    key[0] === "/apps" || key[0] === "/apps/all" || key[0] === "/apps/archived"
  ));
};
